import { isNumber } from '@mote/helpers/assertion'
import styled, { css } from '@xstyled/styled-components'
import { Block } from '../block/block'

function spanFn(value) {
  return value === 'auto'
    ? 'auto'
    : value === 'full'
    ? '1 / -1'
    : `span ${value}/span ${value}`
}

export const Grid = styled.div`
  display: grid;

  grid-template-rows: ${({ rows }) =>
    isNumber(rows) ? `repeat(${rows}, minmax(0, 1fr));` : rows};

  grid-template-columns: ${({ columns }) =>
    isNumber(columns) ? `repeat(${columns}, minmax(0, 1fr));` : columns};

  ${({ gap }) =>
    gap !== undefined &&
    css`
      gap: ${gap}px;
    `}

  ${({ gap, gapX }) =>
    !gap &&
    gapX !== undefined &&
    css`
      column-gap: ${gapX}px;
    `}

  ${({ gap, gapY }) =>
    !gap &&
    gapY !== undefined &&
    css`
      row-gap: ${gapY}px;
    `}

  ${({ autoFlow }) =>
    autoFlow &&
    css`
      grid-auto-flow: ${autoFlow};
    `}

  ${({ autoFlow }) =>
    autoFlow &&
    css`
      grid-auto-flow: ${autoFlow};
    `}

  ${({ autoRows }) => {
    if (!autoRows) return

    switch (autoRows) {
      case 'auto': {
        return css`
          grid-auto-rows: auto;
        `
      }
      case 'min': {
        return css`
          grid-auto-rows: min-content;
        `
      }
      case 'max': {
        return css`
          grid-auto-rows: max-content;
        `
      }
      case 'fr': {
        return css`
          grid-auto-rows: minmax(0, 1fr);
        `
      }
      default: {
        return css`
          grid-auto-rows: ${autoRows};
        `
      }
    }
  }}

  ${({ autoColumns }) => {
    if (!autoColumns) return

    switch (autoColumns) {
      case 'auto': {
        return css`
          grid-auto-columns: auto;
        `
      }
      case 'min': {
        return css`
          grid-auto-columns: min-content;
        `
      }
      case 'max': {
        return css`
          grid-auto-columns: max-content;
        `
      }
      case 'fr': {
        return css`
          grid-auto-columns: minmax(0, 1fr);
        `
      }
      default: {
        return css`
          grid-auto-columns: ${autoColumns};
        `
      }
    }
  }}
`

export const GridItem = styled(Block)`
  ${({ colSpan }) =>
    colSpan &&
    css`
      grid-column: ${spanFn(colSpan)};
    `}

  ${({ rowSpan }) =>
    rowSpan &&
    css`
      grid-row: ${spanFn(rowSpan)};
    `}

  ${({ colStart }) =>
    colStart &&
    css`
      grid-column-start: ${colStart};
    `}

  ${({ colEnd }) =>
    colEnd &&
    css`
      grid-column-end: ${colEnd};
    `}

  ${({ rowStart }) =>
    rowStart &&
    css`
      grid-row-start: ${rowStart};
    `}

  ${({ rowEnd }) =>
    rowEnd &&
    css`
      grid-row-end: ${rowEnd};
    `}
`
